import React, { useEffect } from 'react';
import { SubmitError } from 'Components/Fields/SubmitError';
import { SubmitButton } from 'Components/Fields/Buttons';
import { required, shippingZip } from 'Utils/FormValidation';
import { useForm } from 'Hooks/useForm';
import { FormField } from 'Components/HookFormFields/FormField';
import './ZipCodeForm.css';

export const ZipCodeForm = ({ onFormSubmit, isLoading, setFormValues }) => {
  const formName = 'zipCodeForm';

  const { formFieldProps, submitting, submitDisabled, formError, handleSubmit } = useForm({
    onFormSubmit,
    formName,
  });

  useEffect(() => {
    setFormValues(formFieldProps.fieldValues);
  }, [formFieldProps, setFormValues]);

  return (
    <form onSubmit={(event) => handleSubmit(event)} className="zipCodeForm">
      <div className="title">Enter your zip code to confirm.</div>
      <div className="zipCodeEntry">
        <FormField
          name="zipCode"
          label="Zip Code"
          component="InputField"
          validate={[required, shippingZip]}
          {...formFieldProps}
        />
        <SubmitButton
          className="submitButton"
          isDisabled={submitDisabled}
          text="Submit"
          submitting={submitting || isLoading}
        />
      </div>
      <div className="zipCodeErrorMsg">
        <SubmitError error={formError} formName={formName} />
      </div>
    </form>
  );
};

export default ZipCodeForm;
